import React from 'react';
import { DocumentStatus } from '../../../Components/Billingo/InvoiceStatusPill';
import { docTypeLabel } from '../../../Utils/billingoDocuments';

const SHOWN = 2;

// A row's documents at a glance — the latest two, then a count. Opening the
// row shows all of them (Order Details' Financial tab). `docs` is the list's
// useBookingDocuments.
function BookingDocumentsLine({ row, docs }) {
  const documents = docs.documentsOf(row);

  return (
    <div className="d-flex flex-wrap align-items-center column-gap-3 row-gap-1 small mt-1">
      {docs.noteFor(documents) || (
        <>
          {documents.slice(0, SHOWN).map((doc) => (
            <span key={doc.id} className="text-nowrap">
              {`${docTypeLabel(doc.type)} ${doc.number} `}
              <DocumentStatus doc={doc} />
            </span>
          ))}
          {documents.length > SHOWN && (
            <span className="text-muted">{`+${documents.length - SHOWN} more`}</span>
          )}
        </>
      )}
    </div>
  );
}

export default BookingDocumentsLine;
